import { render, staticRenderFns } from "./RStarRatingDistributionChart.vue?vue&type=template&id=5072700c&scoped=true&"
import script from "./RStarRatingDistributionChart.vue?vue&type=script&lang=js&"
export * from "./RStarRatingDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./RStarRatingDistributionChart.vue?vue&type=style&index=0&id=5072700c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072700c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VProgressLinear,VRow,VSkeletonLoader})
